import AndrewPosey from "./../ASSETS/IMAGES/DOCTORS/KUR_UCCT_Andrew Posey_Osteopathic Medicine_BW.png";
import CharlesArbogast from "./../ASSETS/IMAGES/DOCTORS/KUR_UCCT_Charles Arborgast_Internal Medicine_Nephrology_BW.png";
import ChristopherHansen from "./../ASSETS/IMAGES/DOCTORS/KUR_UCCT_Christopher Hansen_Family Practice_BW.png";
import FredAubert from "./../ASSETS/IMAGES/DOCTORS/KUR_UCCT_Fred_Aubert_Neurology_BW.png";
import JohnDali from "./../ASSETS/IMAGES/DOCTORS/KUR_UCCT_John_Dali_General Surgery_BW.png";
import JohnWaits from "./../ASSETS/IMAGES/DOCTORS/KUR_UCCT_John_Waits_Internal Medicine_Family_Practice_BW.png";
import UsmanWaheed from "./../ASSETS/IMAGES/DOCTORS/KUR_UCCT_Usman Waheed_Pediatrics_BW.png";
import VergilBrown from "./../ASSETS/IMAGES/DOCTORS/KUR_UCCT_Vergil Kenneth Brown_Internal Medicine_BW.png";
import WilliamSaway from "./../ASSETS/IMAGES/DOCTORS/KUR_UCCT_William Saway_Internal Medicine_BW.png";
import JamesBellor from "./../ASSETS/IMAGES/DOCTORS/KUR_UCCT_James_Bellor_Rheumatology_BW.png";
import ScottStrahlman from "./../ASSETS/IMAGES/DOCTORS/KUR_UCCT_ Scott  Strahlman_Pediatrics_bw.png";
import CamilleGo from "./../ASSETS/IMAGES/DOCTORS/KUR_UCCT_Camille Go_pulmonologist_BW.png";
// import DavidHecker from "./../ASSETS/IMAGES/DOCTORS/davidhecker.png";
import DavidHecker from "./../ASSETS/IMAGES/DOCTORS/KUR_UCCT_David Hecker_Dermatologist_BW.png";
// import MelanieHecker from "./../ASSETS/IMAGES/DOCTORS/melaniehecker.png";
import MelanieHecker from "./../ASSETS/IMAGES/DOCTORS/KUR_UCCT_Melanie Hecker_Dermatologist_BW.png";
import AndrewPanakos from "./../ASSETS/IMAGES/DOCTORS/KUR_UCCT_Andrew Panakos_Cardiology_BW.png";
import ThomasBartzokis from "./../ASSETS/IMAGES/DOCTORS/KUR_UCCT_Thomas Bartzokis_Cardiology_BW.png";
import MichaelCammarata from "./../ASSETS/IMAGES/DOCTORS/KUR_UCCT_Michael Cammarata_Cardiology_BW.png";
import BarryMerrill from "./../ASSETS/IMAGES/DOCTORS/KUR_UCCT_Barry Merrill_Cardiology_bw.png";
import DebraBecker from "./../ASSETS/IMAGES/DOCTORS/KUR_UCCT_Debra Becker_Cardiology_BW.png";
import StephenJamesServous from "./../ASSETS/IMAGES/DOCTORS/KUR_UCCT_Stephen James Servous_Cardiology_BW.png";
import MarkRubenstein from "./../ASSETS/IMAGES/DOCTORS/KUR_UCCT_Mark Rubenstein_Cardiology_BW.png";
import HaroonurRashid from "./../ASSETS/IMAGES/DOCTORS/KUR_UCCT_Haroonur_Rashid_Cardiology_BW.png";
import MohamedShalaby from "./../ASSETS/IMAGES/DOCTORS/KUR_UCCT_Mohamed Shalaby_Cardiology_BW.png";
import AramisCosme from "./../ASSETS/IMAGES/DOCTORS/KUR_UCCT_Aramis Cosme_Internal Medicine_bw.png";
import SegunAdeoye from "./../ASSETS/IMAGES/DOCTORS/KUR_UCCT_Segun Adeoye_Family Medicine_BW.png";
import UlomaOkundaye from "./../ASSETS/IMAGES/DOCTORS/KUR_UCCT_Uloma Okundaye_Psychiatry ,Family Medicine_BW.png";
import LanceLaFleur from "./../ASSETS/IMAGES/DOCTORS/KUR_UCCT_Lance LaFleur_Anesthesia_Interventional Pain_BW.png";
import LisaKopas from "./../ASSETS/IMAGES/DOCTORS/KUR_UCCT_Lisa Kopas_Anesthesia_Pulmonary Medicine_BW.png";
import RandalLepow from "./../ASSETS/IMAGES/DOCTORS/KUR_UCCT_Randal Lepow_Podiatry_BW.png";
import MicaelaSimon from "./../ASSETS/IMAGES/DOCTORS/KUR_UCCT_Micaela Simon_Family Medicine_BW.png";
import JuliaKieffer from "./../ASSETS/IMAGES/DOCTORS/KUR_UCCT_Julia_Kieffer_Family_Medicine_BW.png";
import FrankLoVecchio from "./../ASSETS/IMAGES/DOCTORS/KUR_UCCT_Frank LoVecchio_Emergency Medicine_BW.png";
import SamHaddad from "./../ASSETS/IMAGES/DOCTORS/KUR_UCCT_Sam Haddad_Internal Medicine_BW.png";
import ScottMaling from "./../ASSETS/IMAGES/DOCTORS/KUR_UCCT_Scott Maling_Podiatry & Wound Care_BW.png";
import AdamBosak from "./../ASSETS/IMAGES/DOCTORS/KUR_UCCT_Adam Bosak_Pulmonary Medicine_bw.png";
import ArpitPatel from "./../ASSETS/IMAGES/DOCTORS/KUR_UCCT_Arpit Patel_Colorectal Surgeon_bw.png";
import ShawnWebb from "./../ASSETS/IMAGES/DOCTORS/KUR_UCCT_Shawn Webb_Colorectal Surgeon_BW.png";
import HekmatHakiman from "./../ASSETS/IMAGES/DOCTORS/KUR_AXSENDO_Hekmat_Hakiman_bw.png";
import PaulPannozzo from "./../ASSETS/IMAGES/DOCTORS/KUR_UCCT_Paul Pannozzo_Interventional Pain_Physical Medicine_Rehabilitation_BW.png";
import AndyTran from "./../ASSETS/IMAGES/DOCTORS/KUR_UCCT_Andy Tran_Cardiac Electrophysiology_BW.jpg";
import TruongDuong from "./../ASSETS/IMAGES/DOCTORS/KUR_UCCT_Truong Duong_Cardiac Electrophysiology_BW.png";
import NiravMehta from "./../ASSETS/IMAGES/DOCTORS/KUR_UCCT_Nirav Mehta_Interventional Cardiology_BW.png";
import TarpanPatel from "./../ASSETS/IMAGES/DOCTORS/KUR_UCCT_Tarpan Patel_Interventional Cardiology_BW.png";
import StephenSmith from "./../ASSETS/IMAGES/DOCTORS/KUR_UCCT_Stephen Smith_Vascular Surgery_BW.png";
import KevinBerman from "./../ASSETS/IMAGES/DOCTORS/KUR_UCCT_Kevin_Berman_Preventative_Cardiology_BW.png";
import RobertBear from "./../ASSETS/IMAGES/DOCTORS/KUR_UCCT_Robert Bear_Preventative Cardiology_BW.png";
import CarlBalog from "./../ASSETS/IMAGES/DOCTORS/KUR_UCCT_Carl Balog_Anesthesia_Interventional Pain_BW.png";
import RandolphCribbs from "./../ASSETS/IMAGES/DOCTORS/KUR_UCCT_Randolph Cribbs_Occupational Medicine General Surgery_BW.png";
import EfrainCubillo from "./../ASSETS/IMAGES/DOCTORS/KUR_UCCT_Efrain_I_Cubillo_Occupational Medicine General Surgery_BW.png";
import OlumayowaAderinto from "./../ASSETS/IMAGES/DOCTORS/KUR_UCCT_Olumayowa Aderinto_Nephrologist_BW.png";
import JeffreyWolkowitz from "./../ASSETS/IMAGES/DOCTORS/KUR_UCCT_Jeffrey_Wolkowitz_pulmonologist_BW.png";
import ThareshUdupa from "./../ASSETS/IMAGES/DOCTORS/KUR_UCCT_Tharesh Udupa_Wound Care_BW.png";
import JorgeBizet from "./../ASSETS/IMAGES/DOCTORS/KUR_UCCT_Jorge_Bizet_Internal Medicine_BW.jpg";
import YazanAbdeen from "./../ASSETS/IMAGES/DOCTORS/KUR_UCCT_Yazan Abdeen_Anesthesia_Pulmonary_Critical Care Medicine_BW.png";
import DanielKerr from "./../ASSETS/IMAGES/DOCTORS/Daniel_Kerr.png";
import ImadJandali from "./../ASSETS/IMAGES/DOCTORS/Imad_Jandali.png";
import JasonMendivil from "./../ASSETS/IMAGES/DOCTORS/Jason_Mendivil.png";
import LyssaNeidaOchoa from "./../ASSETS/IMAGES/DOCTORS/Lyssa_Neida_Ochoa.png";
import MarcusGitterle from "./../ASSETS/IMAGES/DOCTORS/Marcus_Gitterle.png";
import NirHus from "./../ASSETS/IMAGES/DOCTORS/Nir-Hus.png";
import SunnySajjad from "./../ASSETS/IMAGES/DOCTORS/Sunny_Sajjad.png";
import AdamPlotkin from "./../ASSETS/IMAGES/DOCTORS/AdamPlotkin.webp";
import MatthewUhde from "./../ASSETS/IMAGES/DOCTORS/MatthewUdhe.webp";
import JosephBallarini from "./../ASSETS/IMAGES/DOCTORS/JosephBallarini.jpeg";
import JasonAYoho from "./../ASSETS/IMAGES/DOCTORS/JasonAyoho-MD.png";
import HeatherDO from "./../ASSETS/IMAGES/DOCTORS/Heather_DO.png";


export const investigators = [
   {
    image: HeatherDO,
    name: "Heather G Aguirre, DO",
    TheraupaticalArea: ["Vascular Surgery"],
    specialization: ["Vascular Surgery"],
    site: "KUR Research @ The Save Clinic – San Antonio, TX",
    // link: "/network/cv/andrew-posey-do",
    link: "/network/cv/Dr. Lyssa Neida Ochoa -Vascular Surgery- TX-3.31.2026.pdf",
    location: { state: "Texas", city: "San Antonio" },
    yearsPracticalPhysician: "",
    yearsResearchClinicalTrail: "",
    numberOfClinicalTrail: 0,
  },
   {
    image: JasonAYoho,
    name: "Jason A. Yoho, MD",
    TheraupaticalArea: ["Wound Care"],
    specialization: ["Wound Care"],
    site: "KUR Research @ Wound Centric – New Braunfels, TX",
    // link: "/network/cv/andrew-posey-do",
    link: "/network/cv/Dr. Marcus L. Gitterle - KUR - Wound Care- TX - 3.31.2025.pdf",
    location: { state: "Texas", city: "New Braunfels" },
    yearsPracticalPhysician: "13+ yrs ",
    yearsResearchClinicalTrail: "13+ yrs ",
    numberOfClinicalTrail: 15,
  },
  {
    image: AndrewPosey,
    name: "Andrew D. Posey, DO",
    TheraupaticalArea: ["Primary Care"],
    specialization: ["Osteopathic Medicine"],
    site: "KUR Research @ Cahaba Medical Group – Bessemer, AL",
    // link: "/network/cv/andrew-posey-do",
    link: "/network/cv/Dr. Andrew Posey - KUR - Osteopathic Medicine AL - 09.22.2025.pdf",
    location: { state: "Alabama", city: "Bessemer" },
    yearsPracticalPhysician: "12+ yrs ",
    yearsResearchClinicalTrail: "4+ yrs ",
    numberOfClinicalTrail: 10,
  },
//  {
//     image: DanielKerr,
//     name: "Daniel A. Kerr II,Ph.D.",
//     TheraupaticalArea: ["Oncology"],
//     specialization: ["Oncologist"],
//     site: "KUR Partnership @ FWD Clinical Research - Brooksville, FL",
//     // link: "/network/cv/andrew-posey-do",
//     link: "/network/cv/Dr. Daniel A. Kerr II- FWD - KUR - Oncologist -FL - 02.19.2025.pdf",
//     location: { state: "Florida", city: "Brooksville" },
//     yearsPracticalPhysician: "7+ yrs ",
//     yearsResearchClinicalTrail: "7+ yrs ",
//     numberOfClinicalTrail: 19,
//   },
  {
    image: AdamPlotkin,
    name: "Adam S. Plotkin, MD",
    TheraupaticalArea: ["Dermatology"],
    specialization: ["Dermatologist"],
    site: "KUR Research @ Palm Beach Dermatology Group - Delray Beach, FL",
    // link: "/network/cv/andrew-posey-do",
    link: "/network/cv/Dr. Adam S. Plotkin - KUR - Dermatologist - FL - 08.3.2026.pdf",
    location: { state: "Florida", city: "Delray Beach" },
    yearsPracticalPhysician: "10+ yrs ",
    yearsResearchClinicalTrail: "10+ yrs ",
    numberOfClinicalTrail: 35,
  },
  {
    image: MatthewUhde,
    name: "Matthew Uhde, DO",
    TheraupaticalArea: ["Dermatology"],
    specialization: ["Dermatologist"],
    site: "KUR Research @ Palm Beach Dermatology Group - Delray Beach, FL",
    // link: "/network/cv/andrew-posey-do",
    link: "/network/cv/Dr. Matthew Uhde - KUR - Dermatologist FL - 08.3.2026.pdf",
    location: { state: "Florida", city: "Delray Beach" },
    yearsPracticalPhysician: "5+ yrs ",
    yearsResearchClinicalTrail: "5+ yrs ",
    numberOfClinicalTrail: 35,
  },
  //  {
  //   image: ImadJandali,
  //   name: "Imad Jandali, MD",
  //   TheraupaticalArea: ["Pediatrics"],
  //   specialization: ["Pediatrics"],
  //   site: "KUR Partnership @ FWD Clinical Research - Springhill, FL",
  //   // link: "/network/cv/andrew-posey-do",
  //   link: "/network/cv/Dr. Imad Jandali - FWD - KUR - Pediatrician - FL - 2.19.2026.pdf",
  //   location: { state: "Florida", city: "Springhill" },
  //   yearsPracticalPhysician: "37+ yrs ",
  //   yearsResearchClinicalTrail: "10+ yrs ",
  //   numberOfClinicalTrail: 31,
  // },
///new doctors
{
    image: JasonMendivil,
    name: "Jason M. Mendivil, DPM",
    TheraupaticalArea: ["Podiatric surgery"],
    specialization: ["Podiatric surgery"],
    site: "KUR Research @ Mendivil Clinic –  El Paso, TX",
    // link: "/network/cv/andrew-posey-do",
    link: "/network/cv/Dr. Jason M Mendivil, DPM - Foot and Ankle Surgery-TX - 3.31.2026.pdf",
    location: { state: "Texas", city: "El Paso" },
    yearsPracticalPhysician: "16+ yrs ",
    yearsResearchClinicalTrail: "",
    numberOfClinicalTrail: "",
  },
  {
    image: LyssaNeidaOchoa,
    name: "Lyssa Neida Ochoa, MD",
    TheraupaticalArea: ["Vascular Surgery"],
    specialization: ["Vascular Surgery"],
    site: "KUR Research @ The Save Clinic – San Antonio, TX",
    // link: "/network/cv/andrew-posey-do",
    link: "/network/cv/Dr. Lyssa Neida Ochoa -Vascular Surgery- TX-3.31.2026.pdf",
    location: { state: "Texas", city: "San Antonio" },
    yearsPracticalPhysician: "15+ yrs ",
    yearsResearchClinicalTrail: "4+ yrs ",
    numberOfClinicalTrail: 4,
  },
  {
    image: MarcusGitterle,
    name: "Marcus L. Gitterle, M.D. FACCWS",
    TheraupaticalArea: ["Wound Care"],
    specialization: ["Wound Care"],
    site: "KUR Research @ Wound Centric – Corpus Christi, TX",
    // link: "/network/cv/andrew-posey-do",
    link: "/network/cv/Dr. Marcus L. Gitterle - KUR - Wound Care- TX - 3.31.2025.pdf",
    location: { state: "Texas", city: "Corpus Christi" },
    yearsPracticalPhysician: "35+ yrs ",
    yearsResearchClinicalTrail: "",
    numberOfClinicalTrail: "",
  },
  {
    image: NirHus,
    name: "Nir Joseph Hus, M.D., Ph.D., FACS",
    TheraupaticalArea: ["General Surgeon"],
    specialization: ["General Surgeon"],
    site: "KUR Research @ South Florida Premier Surgery – Delray Beach, FL",
    // link: "/network/cv/andrew-posey-do",
    link: "/network/cv/Dr. Nir Joseph Hus -Trauma and General surgeon -FL - 3.31.2026.pdf",
    location: { state: "Florida", city: "Delray Beach" },
    yearsPracticalPhysician: "15+ yrs ",
    yearsResearchClinicalTrail: "",
    numberOfClinicalTrail: "",
  },
   {
    image: JosephBallarini,
    name: "V. Joseph Ballarini, D.O",
    TheraupaticalArea: ["Emergency Medicine"],
    specialization: ["Emergency Medicine"],
    site: "KUR Research @ FL-Miami Beach-Miami Beach Urgent Care",
    // link: "/network/cv/andrew-posey-do",
    link: "/network/cv/Dr. Nir Joseph Hus -Trauma and General surgeon -FL - 3.31.2026.pdf",
    location: { state: "Florida", city: "Delray Beach" },
    yearsPracticalPhysician: "",
    yearsResearchClinicalTrail: "",
    numberOfClinicalTrail: "",
  },
  // {
  //   image: SunnySajjad,
  //   name: "Sunny Sajjad,DPM, MS, DABPM",
  //   TheraupaticalArea: ["Podiatric"],
  //   specialization: ["Podiatric"],
  //   site: "KUR Research @ Wound Centric – Corpus Christi, TX",
  //   // link: "/network/cv/andrew-posey-do",
  //   link: "/network/cv/Dr. Sunny Sajjad- KUR - Podiatric- TX - 3.31.2025.pdf",
  //   location: { state: "Texas", city: "Corpus Christi" },
  //   yearsPracticalPhysician: "7+ yrs ",
  //   yearsResearchClinicalTrail: "10+ yrs ",
  //   numberOfClinicalTrail: 10,
  // },

  ///end new doctors

  // {
  //   image: CarlBalog,
  //   name: "Carl C. Balog, M.D.",
  //   TheraupaticalArea: ["Anesthesia", "Interventional Pain"],
  //   specialization: ["Anesthesia, Interventional Pain"],
  //   site: "KUR @ Axsendo Clinical Research – Portland, OR",
  //   link: "/network/cv/Dr. Carl C. Balog - ACR - KUR - Anesthesia Interventional Pain OR - 9.25.2025.pdf",
  //   location: { state: "OREGON", city: "Portland" },
  //   yearsPracticalPhysician: "30++ yrs ",
  //   yearsResearchClinicalTrail: "13+ yrs ",
  //   numberOfClinicalTrail: 3,
  // },
  // {
  //   image: EfrainCubillo,
  //   name: "Efrain I. Cubillo, IV",
  //   TheraupaticalArea: ["General Surgery", "Occupational Med / Physical Med"],
  //   specialization: ["Occupational Medicine General Surgery"],
  //   site: "KUR @ Axsendo Clinical Research – Portland, OR",
  //   link: "/network/cv/Dr. Efrain Cubillo - ACR - KUR - Occupational Medicine General Surgery OR - 9.22.2025.pdf",
  //   location: { state: "OREGON", city: "Portland" },
  //   yearsPracticalPhysician: "23+ yrs ",
  //   yearsResearchClinicalTrail: "13+ yrs ",
  //   numberOfClinicalTrail: 2,
  // },
  // {
  //   image: RandolphCribbs,
  //   name: "Randolph Cribbs, M.D.",
  //   TheraupaticalArea: ["General Surgery", "Occupational Med / Physical Med"],
  //   specialization: ["Occupational Medicine General Surgery"],
  //   site: "KUR @ Axsendo Clinical Research – Portland, OR",
  //   link: "/network/cv/Dr. Randolf Cribbs -ACR - KUR - Occupational Medicine General Surgery OR - 09.23.2025.pdf",
  //   location: { state: "OREGON", city: "Portland" },
  //   yearsPracticalPhysician: "20+ yrs ",
  //   yearsResearchClinicalTrail: "",
  //   numberOfClinicalTrail: "",
  // },
  // {
  //   image: UsmanWaheed,
  //   name: "Usman Waheed, M.D.",
  //   TheraupaticalArea: ["Wound Care"],
  //   specialization: ["Wound Care"],
  //   site: "KUR Research @ Colombia Medical Practice – Columbia, MD",
  //   link: "/network/cv/Dr. Usman Waheed - KUR - Wound Care MD - 9.22.2025.pdf",
  //   location: { state: "Maryland", city: "Columbia" },
  //   yearsPracticalPhysician: "20+ yrs ",
  //   yearsResearchClinicalTrail: "",
  //   numberOfClinicalTrail: "",
  // },
  {
    image: ScottStrahlman,
    name: "R. Scott Strahlman, M.D., FAAFP",
    TheraupaticalArea: ["Pediatrics"],
    specialization: ["Pediatrics"],
    site: "KUR Research @ Colombia Medical Practice – Columbia, MD",
    link: "/network/cv/Dr. Scott Strahlman - KUR - Pediatrics MD - 09.22.2025.pdf",
    location: { state: "Maryland", city: "Columbia" },
    yearsPracticalPhysician: "20+ yrs ",
    yearsResearchClinicalTrail: "20+ yrs ",
    numberOfClinicalTrail: 24,
  },

  {
    image: WilliamSaway,
    name: "William Saway, M.D., FACP",
    TheraupaticalArea: ["Primary Care"],
    specialization: ["Internal Medicine"],
    site: "KUR Research @ Colombia Medical Practice – Columbia, MD",
    link: "/network/cv/Dr. William Saway - KUR - Internal medicine MD - 09.22.2025.pdf",
    location: {
      state: "Maryland",
      city: "Columbia",
    },
    yearsPracticalPhysician: "30+ yrs ",
    yearsResearchClinicalTrail: "20+ yrs ",
    numberOfClinicalTrail: 87,
  },
  {
    image: JamesBellor,
    name: "James R. Bellor, M.D.",
    TheraupaticalArea: ["Rheumatology"],
    specialization: ["Rheumatology"],
    site: "KUR Research @ Colombia Medical Practice – Columbia, MD",
    link: "/network/cv/Dr. James R. Bellor - KUR - Rheumatology MD - 9.22.2025.pdf",
    location: {
      state: "Maryland",
      city: "Columbia",
    },
    yearsPracticalPhysician: "40+ yrs ",
    yearsResearchClinicalTrail: "24+ yrs ",
    numberOfClinicalTrail: 53,
  },
  {
    image: JohnWaits,
    name: "John B. Waits, M.D., FAAFP",
    TheraupaticalArea: ["Primary Care"],
    specialization: ["Internal Medicine, Family Practice"],
    site: "KUR Research @ Cahaba Medical Group – Centreville, AL",
    link: "/network/cv/Dr. John Waits - KUR - Family Medicine AL - 09.22.2025.pdf",
    location: {
      state: "Alabama",
      city: "Centreville",
    },
    yearsPracticalPhysician: "21+ yrs ",
    yearsResearchClinicalTrail: "4+ yrs ",
    numberOfClinicalTrail: 7,
  },
  // {
  //   image: VergilBrown,
  //   name: "Vergil Kenneth Brown III, M.D., PhD",
  //   TheraupaticalArea: ["Primary Care"],
  //   specialization: ["Internal Medicine"],
  //   site: "KUR Research @ White Wilson Medical Center – Fort Walton Beach, FL",
  //   link: "/network/cv/Dr. Virgil Brown - KUR - Internal Medicine FL - 9.22.2025.pdf",
  //   location: {
  //     state: "Florida",
  //     city: "Fort Walton Beach",
  //   },
  //   yearsPracticalPhysician: "",
  //   yearsResearchClinicalTrail: "",
  //   numberOfClinicalTrail: "",
  // },
  // {
  //   image: ChristopherHansen,
  //   name: "Christopher M.Hansen, M.D.",
  //   TheraupaticalArea: ["Primary Care"],
  //   specialization: ["Family Practice"],
  //   site: "KUR Research @ White Wilson Medical Center – Fort Walton Beach, FL",
  //   link: "/network/cv/Dr. Christopher Hansen - KUR - Family Medicine FL - 9.22.2025.pdf",
  //   location: {
  //     state: "Florida",
  //     city: "Fort Walton Beach",
  //   },
  //   yearsPracticalPhysician: "",
  //   yearsResearchClinicalTrail: "",
  //   numberOfClinicalTrail: "",
  // },
  // {
  //   image: JohnDali,
  //   name: "John C. Dali, M.D.",
  //   TheraupaticalArea: ["Wound Care", "General Surgery"],
  //   specialization: ["General Surgery"],
  //   site: "KUR Research @ White Wilson Medical Center – Fort Walton Beach, FL",
  //   link: "/network/cv/Dr. John Dali - KUR - General Surgery FL - 9.22.2025.pdf",
  //   location: {
  //     state: "Florida",
  //     city: "Fort Walton Beach",
  //   },
  //   yearsPracticalPhysician: "",
  //   yearsResearchClinicalTrail: "36+ yrs",
  //   numberOfClinicalTrail: "4",
  // },
  // {
  //   image: CharlesArbogast,
  //   name: "Charles B. Arbogast, D.O.",
  //   TheraupaticalArea: ["Primary Care", "Nephrology"],
  //   specialization: ["Internal Medicine, Nephrology"],
  //   site: "KUR Research @ White Wilson Medical Center – Fort Walton Beach, FL",
  //   link: "/network/cv/Dr. Charles Arbogast - KUR - Nephrology FL - 9.23.2025.pdf",
  //   location: {
  //     state: "Florida",
  //     city: "Fort Walton Beach",
  //   },
  //   yearsPracticalPhysician: "",
  //   yearsResearchClinicalTrail: "",
  //   numberOfClinicalTrail: "",
  // },
  // {
  //   image: FredAubert,
  //   name: "Fred E. Aubert, JR, M.D.",
  //   TheraupaticalArea: ["Neurology"],
  //   specialization: ["Neurology"],
  //   site: "KUR Research @ White Wilson Medical Center – Fort Walton Beach, FL",
  //   link: "/network/cv/Dr. Fred Aubert - KUR - Neurology FL - 9.22.2025.pdf",
  //   location: {
  //     state: "Florida",
  //     city: "Fort Walton Beach",
  //   },
  //   yearsPracticalPhysician: "",
  //   yearsResearchClinicalTrail: "",
  //   numberOfClinicalTrail: "",
  // },
  // {
  //   image: CamilleGo,
  //   name: "Camille Celeste Go, M.D, BSN, RN",
  //   TheraupaticalArea: ["Primary Care"],
  //   specialization: ["Family Medicine"],
  //   site: "KUR Partnership @ FWD Clinical Research – Tamarac, FL",
  //   link: "/network/cv/Dr. Camille Celeste Go - FWD - KUR - Family Medicine FL - 09.23.2025.pdf",
  //   location: {
  //     state: "Florida",
  //     city: "Tamarac",
  //   },
  //   yearsPracticalPhysician: "8+ yrs ",
  //   yearsResearchClinicalTrail: "6+ yrs ",
  //   numberOfClinicalTrail: "4",
  // },
  {
    image: DavidHecker,
    name: "David J. Hecker, M.D.",
    TheraupaticalArea: ["Dermatology"],
    specialization: ["Dermatologist"],
    site: "KUR Partnership @ FWD Clinical Research – Tamarac, FL",
    link: "/network/cv/Dr. David J. Hecker - FWD - KUR - Dermatology FL - 09.23.2025.pdf",
    location: {
      state: "Florida",
      city: "Tamarac",
    },
    yearsPracticalPhysician: "39+ yrs ",
    yearsResearchClinicalTrail: "30+ yrs ",
    numberOfClinicalTrail: "18",
  },
  {
    image: MelanieHecker,
    name: "Melanie S. Hecker, M.D., M.B.A.",
    TheraupaticalArea: ["Dermatology"],
    specialization: ["Dermatologist"],
    site: "KUR Partnership @ FWD Clinical Research – Tamarac, FL",
    link: "/network/cv/Dr. Melanie S. Hecker - FWD - KUR - Dermatology FL - 09.23.2025.pdf",
    location: {
      state: "Florida",
      city: "Tamarac",
    },
    yearsPracticalPhysician: "44+ yrs ",
    yearsResearchClinicalTrail: "9+ yrs ",
    numberOfClinicalTrail: "16",
  },
  // {
  //   image: AndrewPanakos,
  //   name: "Andrew W. Panakos, M.D.",
  //   TheraupaticalArea: ["Cardiology"],
  //   specialization: ["Cardiology"],
  //   site: "KUR Partnership @ FWD Clinical Research – Boca Raton, FL",
  //   link: "/network/cv/Dr. Andrew W. Panakos - FWD - KUR - Cardiology FL - 09.23.2025 .pdf",
  //   location: {
  //     state: "Florida",
  //     city: "Boca Raton",
  //   },
  //   yearsPracticalPhysician: "5+ yrs ",
  //   yearsResearchClinicalTrail: "5+ yrs ",
  //   numberOfClinicalTrail: "14",
  // },
  {
    image: JeffreyWolkowitz,
    name: "Jeffrey Wolkowicz, M.D.",
    TheraupaticalArea: ["Pulmonology"],
    specialization: ["Pulmonologist"],
    site: "KUR Partnership @ FWD Clinical Research – Boca Raton, FL",
    link: "/network/cv/Dr. Jeffrey Wolkowitz  - FWD - KUR - Pulmonology FL - 09.23.2025.pdf",
    location: {
      state: "Florida",
      city: "Boca Raton",
    },
    yearsPracticalPhysician: "35+ yrs ",
    yearsResearchClinicalTrail: "3+ yrs ",
    numberOfClinicalTrail: "3",
  },
  // {
  //   image: ThomasBartzokis,
  //   name: "Thomas C.Bartzokis, M.D., F.A.C.C",
  //   TheraupaticalArea: ["Cardiology"],
  //   specialization: ["Cardiology"],
  //   site: "KUR Partnership @ FWD Clinical Research – Boca Raton, FL",
  //   link: "/network/cv/Dr. Thomas C. Bartzokis - FWD - KUR - Cardiology FL - 09.23.2025.pdf",
  //   location: {
  //     state: "Florida",
  //     city: "Boca Raton",
  //   },
  //   yearsPracticalPhysician: "37+ yrs ",
  //   yearsResearchClinicalTrail: "9+ yrs ",
  //   numberOfClinicalTrail: "16",
  // },
  // {
  //   image: MichaelCammarata,
  //   name: "Michael W.Cammarata, M.D.,",
  //   TheraupaticalArea: ["Cardiology"],
  //   specialization: ["Cardiology"],
  //   site: "KUR Partnership @ FWD Clinical Research – Boca Raton, FL",
  //   link: "/network/cv/Dr. Michael W. Cammarata - FWD - KUR - Cardiology FL- 09.23.2025.pdf",
  //   location: {
  //     state: "Florida",
  //     city: "Boca Raton",
  //   },
  //   yearsPracticalPhysician: "9+ yrs ",
  //   yearsResearchClinicalTrail: "9+ yrs ",
  //   numberOfClinicalTrail: "16",
  // },
  // {
  //   image: BarryMerrill,
  //   name: "Barry S. Merrill, M.D.",
  //   TheraupaticalArea: ["Cardiology"],
  //   specialization: ["Cardiology"],
  //   site: "KUR Partnership @ FWD Clinical Research – Boca Raton, FL",
  //   link: "/network/cv/Dr. Barry S. Merrill - FWD - KUR - Cardilogy FL - 09.23.2025.pdf",
  //   location: {
  //     state: "Florida",
  //     city: "Boca Raton",
  //   },
  //   yearsPracticalPhysician: "23+ yrs ",
  //   yearsResearchClinicalTrail: "9+ yrs ",
  //   numberOfClinicalTrail: "16",
  // },
  // {
  //   image: DebraBecker,
  //   name: "Debra Becker, M.D.",
  //   TheraupaticalArea: ["Cardiology"],
  //   specialization: ["Cardiology"],
  //   site: "KUR Partnership @ FWD Clinical Research – Boca Raton, FL",
  //   link: "/network/cv/Dr. Debra Becker - FWD - KUR - Cardiology FL - 09.23.2025.pdf",
  //   location: {
  //     state: "Florida",
  //     city: "Boca Raton",
  //   },
  //   yearsPracticalPhysician: "35+ yrs ",
  //   yearsResearchClinicalTrail: "8+ yrs ",
  //   numberOfClinicalTrail: "16",
  // },
  // {
  //   image: StephenJamesServous,
  //   name: "Stephen James Servous, M.D., M.Sc., F.A.C.C., F.S.C.A.I,",
  //   TheraupaticalArea: ["Cardiology"],
  //   specialization: ["Cardiology"],
  //   site: "KUR Partnership @ FWD Clinical Research – Boca Raton, FL",
  //   link: "/network/cv/Dr. Stephen Servous - FWD - KUR - Cardiology FL - 09.23.2025.pdf",
  //   location: {
  //     state: "Florida",
  //     city: "Boca Raton",
  //   },
  //   yearsPracticalPhysician: "20+ yrs ",
  //   yearsResearchClinicalTrail: "7+ yrs ",
  //   numberOfClinicalTrail: "5",
  // },
  // {
  //   image: MarkRubenstein,
  //   name: "Mark Rubenstein, M.D.",
  //   TheraupaticalArea: ["Cardiology"],
  //   specialization: ["Cardiology"],
  //   site: "KUR Partnership @ FWD Clinical Research – Boca Raton, FL",
  //   link: "/network/cv/Dr. Mark Rubenstein - FWD - KUR - Cardiology FL - 09.23.2025.pdf",
  //   location: {
  //     state: "Florida",
  //     city: "Boca Raton",
  //   },
  //   yearsPracticalPhysician: "23+ yrs ",
  //   yearsResearchClinicalTrail: "8+ yrs ",
  //   numberOfClinicalTrail: "16",
  // },
  // {
  //   image: SegunAdeoye,
  //   name: "Segun Patrick Adeoye, M.D.",
  //   TheraupaticalArea: ["Primary Care"],
  //   specialization: ["Family Medicine"],
  //   site: "KUR @ Axsendo Clinical Research – Houston, TX",
  //   link: "/network/cv/Dr. Segun Patrick Adeoye - ACR - KUR - Family Medicine TX - 9.23.2025.pdf",
  //   location: {
  //     state: "Texas",
  //     city: "Houston",
  //   },
  //   yearsPracticalPhysician: "25+ yrs ",
  //   yearsResearchClinicalTrail: "24+ yrs ",
  //   numberOfClinicalTrail: "8",
  // },
  // {
  //   image: OlumayowaAderinto,
  //   name: "Olumayowa Aderinto, M.D.",
  //   TheraupaticalArea: ["Nephrology"],
  //   specialization: ["Nephrologist"],
  //   site: "KUR @ Axsendo Clinical Research – Houston, TX",
  //   link: "/network/cv/Dr. Olumayowa Aderinto - ACR - KUR - Nephrology TX - 9.23.2025.pdf",
  //   location: {
  //     state: "Texas",
  //     city: "Houston",
  //   },
  //   yearsPracticalPhysician: "15+ yrs ",
  //   yearsResearchClinicalTrail: "2+ yrs ",
  //   numberOfClinicalTrail: "2",
  // },
  // {
  //   image: ArpitPatel,
  //   name: "Arpit Patel, M.D., FACS, FASCRS",
  //   TheraupaticalArea: ["Gastroenterology"],
  //   specialization: ["Colorectal Surgeon"],
  //   site: "KUR @ Axsendo Clinical Research – Phoenix, AZ",
  //   link: "/network/cv/Dr. Arpit Patel - ACR - KUR - Colorectal Surgery & GI - TX - 9.23.2025.pdf",
  //   location: {
  //     state: "Arizona",
  //     city: "Phoenix",
  //   },
  //   yearsPracticalPhysician: "25+ yrs ",
  //   yearsResearchClinicalTrail: "17+ yrs ",
  //   numberOfClinicalTrail: "13",
  // },
  // {
  //   image: ThareshUdupa,
  //   name: "Tharesh Udupa, DPM, FAPWHc, FAPWCA",
  //   TheraupaticalArea: ["Wound Care"],
  //   specialization: ["Wound Care"],
  //   site: "KUR @ Axsendo Clinical Research – Phoenix, AZ",
  //   link: "/network/cv/Dr.Tharesh Udupa - ACR - KUR - Wound Care AZ - 09.23.2025.pdf",
  //   location: {
  //     state: "Arizona",
  //     city: "Phoenix",
  //   },
  //   yearsPracticalPhysician: "17+ yrs ",
  //   yearsResearchClinicalTrail: "1 Year",
  //   numberOfClinicalTrail: "1",
  // },
  // {
  //   image: AndyTran,
  //   name: "Andy Hoang Thai Tran, M.D.",
  //   TheraupaticalArea: ["Cardiology"],
  //   specialization: ["Cardiac Electrophysiology"],
  //   site: "KUR @ Axsendo Clinical Research – Surprise, AZ",
  //   link: "/network/cv/Dr. Andy Hoang Thai Tran - ACR - KUR - Cardiac Electrophysiology AZ - 9.23.2025.pdf",
  //   location: {
  //     state: "Arizona",
  //     city: "Surprise",
  //   },
  //   yearsPracticalPhysician: "21+ yrs ",
  //   yearsResearchClinicalTrail: "11+ yrs ",
  //   numberOfClinicalTrail: "6",
  // },
  // {
  //   image: RobertBear,
  //   name: "Robert Bear, DO, FACC ",
  //   TheraupaticalArea: ["Cardiology"],
  //   specialization: ["Preventative Cardiology"],
  //   site: "KUR @ Axsendo Clinical Research – Surprise, AZ",
  //   link: "/network/cv/Dr. Robert Bear - ACR - KUR - Preventive Cardiology AZ - 9.24.2025.pdf",
  //   location: {
  //     state: "Arizona",
  //     city: "Surprise",
  //   },
  //   yearsPracticalPhysician: "36+ yrs ",
  //   yearsResearchClinicalTrail: "",
  //   numberOfClinicalTrail: "",
  // },
  // {
  //   image: KevinBerman,
  //   name: "Kevin M. Berman, M.D., F.A.C.C",
  //   TheraupaticalArea: ["Cardiology"],
  //   specialization: ["Preventative Cardiology"],
  //   site: "KUR @ Axsendo Clinical Research – Surprise, AZ",
  //   link: "/network/cv/Dr. Kevin Berman - ACR - KUR - Preventative Cardiology AZ - 09.23.2025.pdf",
  //   location: {
  //     state: "Arizona",
  //     city: "Surprise",
  //   },
  //   yearsPracticalPhysician: "34+ yrs ",
  //   yearsResearchClinicalTrail: "26+ yrs ",
  //   numberOfClinicalTrail: "20",
  // },
  // {
  //   image: StephenSmith,
  //   name: "R.Stephen T. Smith, M.D., FACS",
  //   TheraupaticalArea: ["Vascular Surgery"],
  //   specialization: ["Vascular Surgery"],
  //   site: "KUR @ Axsendo Clinical Research – Surprise, AZ",
  //   link: "/network/cv/Dr. Stephen T.Smith - ACR - KUR - Vascular Surgery AZ - 9.23.2025.pdf",
  //   location: {
  //     state: "Arizona",
  //     city: "Surprise",
  //   },
  //   yearsPracticalPhysician: "17+ yrs ",
  //   yearsResearchClinicalTrail: "15+ yrs ",
  //   numberOfClinicalTrail: "5",
  // },
  // {
  //   image: NiravMehta,
  //   name: "Nirav J. Mehta, M.D., FACC",
  //   TheraupaticalArea: ["Cardiology"],
  //   specialization: ["Interventional Cardiology"],
  //   site: "KUR @ Axsendo Clinical Research – Surprise, AZ",
  //   link: "/network/cv/Dr. Nirav J. Mehta - ACR - KUR - Interventional Cardiology AZ- 9.23.2025.pdf",
  //   location: {
  //     state: "Arizona",
  //     city: "Surprise",
  //   },
  //   yearsPracticalPhysician: "24+ yrs ",
  //   yearsResearchClinicalTrail: "5+ yrs ",
  //   numberOfClinicalTrail: "5",
  // },
  // {
  //   image: TarpanPatel,
  //   name: "Tarpan Patel, M.D., FACC",
  //   TheraupaticalArea: ["Cardiology"],
  //   specialization: ["Interventional Cardiology"],
  //   site: "KUR @ Axsendo Clinical Research – Surprise, AZ",
  //   link: "/network/cv/Dr. Tarpan Patel - ACR - KUR - Interventional Cardiology AZ - 9.23.2025.pdf",
  //   location: {
  //     state: "Arizona",
  //     city: "Surprise",
  //   },
  //   yearsPracticalPhysician: "10+ yrs ",
  //   yearsResearchClinicalTrail: "5+ yrs ",
  //   numberOfClinicalTrail: "5",
  // },
  // {
  //   image: TruongDuong,
  //   name: "Truong Duong, M.D.",
  //   TheraupaticalArea: ["Cardiology"],
  //   specialization: ["Cardiac Electrophysiology"],
  //   site: "KUR @ Axsendo Clinical Research – Surprise, AZ",
  //   link: "/network/cv/Dr. Truong Duong - ACR - KUR - Cardiac Electrophysiology AZ - 9.23.2025.pdf",
  //   location: {
  //     state: "Arizona",
  //     city: "Surprise",
  //   },
  //   yearsPracticalPhysician: "23+ yrs ",
  //   yearsResearchClinicalTrail: "23+ yrs ",
  //   numberOfClinicalTrail: "5",
  // },
  // {
  //   image: PaulPannozzo,
  //   name: "Paul Pannozzo, M.D.",
  //   TheraupaticalArea: [
  //     "Interventional Pain",
  //     "Occupational Med / Physical Med",
  //   ],
  //   specialization: ["Interventional Pain, Physical Medicine & Rehabilitation"],
  //   site: "KUR @ Axsendo Clinical Research – Phoenix, AZ",
  //   link: "/network/cv/Dr.Paul Pannozzo - ACR - KUR - Interventional Medicine Physical Medicine Rehabilitation AZ.PDF",
  //   location: {
  //     state: "Arizona",
  //     city: "Phoenix",
  //   },
  //   yearsPracticalPhysician: "20+ yrs ",
  //   yearsResearchClinicalTrail: "2+ yrs ",
  //   numberOfClinicalTrail: "2",
  // },
  // {
  //   image: HekmatHakiman,
  //   name: "Hekmat Hakiman, M.D., FACS, FASCRS",
  //   TheraupaticalArea: ["Gastroenterology"],
  //   specialization: ["Colorectal Surgeon"],
  //   site: "KUR @ Axsendo Clinical Research – Phoenix, AZ",
  //   link: "/network/cv/Dr. Hekmat Hakiman  - ACR - KUR - Colorectal Surgeon AZ - 9.23.2025.pdf",
  //   location: {
  //     state: "Arizona",
  //     city: "Phoenix",
  //   },
  //   yearsPracticalPhysician: "10+ yrs ",
  //   yearsResearchClinicalTrail: "",
  //   numberOfClinicalTrail: "",
  // },
  // {
  //   image: ShawnWebb,
  //   name: "Shawn Webb, M.D., FASCRS",
  //   TheraupaticalArea: ["Gastroenterology"],
  //   specialization: ["Colorectal Surgeon"],
  //   site: "KUR @ Axsendo Clinical Research – Phoenix, AZ",
  //   link: "/network/cv/Dr. Shawn Webb - ACR - KUR - Colorectal Surgery - AZ - 09.25.2025.pdf",
  //   location: {
  //     state: "Arizona",
  //     city: "Phoenix",
  //   },
  //   yearsPracticalPhysician: "13+ yrs ",
  //   yearsResearchClinicalTrail: "13+ yrs ",
  //   numberOfClinicalTrail: "10",
  // },
  // {
  //   image: AdamBosak,
  //   name: "Adam Bosak, M.D.",
  //   TheraupaticalArea: ["Pulmonology"],
  //   specialization: ["Pulmonary Medicine"],
  //   site: "KUR @ Axsendo Clinical Research – Phoenix, AZ",
  //   link: "/network/cv/Dr. Adam Bosak - ACR - KUR - Pulmonary Medicine - AZ - 9.23.2025.pdf",
  //   location: {
  //     state: "Arizona",
  //     city: "Phoenix",
  //   },
  //   yearsPracticalPhysician: "7+ yrs ",
  //   yearsResearchClinicalTrail: "1 Year",
  //   numberOfClinicalTrail: "2",
  // },
  // {
  //   image: ScottMaling,
  //   name: "Scott Maling, DPM, FACFAS",
  //   TheraupaticalArea: ["Podiatry", "Wound Care"],
  //   specialization: ["Podiatry & Wound Care"],
  //   site: "KUR @ Axsendo Clinical Research  – Phoenix, AZ",
  //   link: "/network/cv/Dr. Scott Maling- ACR-KUR - Podiatry & Wound Care AZ- 9.23.2025.pdf",
  //   location: {
  //     state: "Arizona",
  //     city: "Phoenix",
  //   },
  //   yearsPracticalPhysician: "19+ yrs ",
  //   yearsResearchClinicalTrail: "5+ yrs ",
  //   numberOfClinicalTrail: "5",
  // },
  // {
  //   image: HaroonurRashid,
  //   name: "Haroonur Rashid, M.D., PH.D., F.A.C.C., F.S.C.A.I.",
  //   TheraupaticalArea: ["Cardiology"],
  //   specialization: ["Cardiology"],
  //   site: "KUR @ Axsendo Clinical Research – Houston, TX",
  //   link: "/network/cv/Dr. Haroonur Rashid - ACR - KUR - Cardiology TX - 9.23.2025.pdf",
  //   location: { state: "Texas", city: "Houston" },
  //   yearsPracticalPhysician: "24+ yrs ",
  //   yearsResearchClinicalTrail: "18+ yrs ",
  //   numberOfClinicalTrail: "14",
  // },
  // {
  //   image: JorgeBizet,
  //   name: "Jorge Bizet, M.D.",
  //   TheraupaticalArea: ["Primary Care"],
  //   specialization: ["Internal Medicine"],
  //   site: "KUR @ Axsendo Clinical Research – Houston, TX",
  //   link: "/network/cv/Dr. Jorge Bizet - ACR - KUR - Internal Medicine TX - 9.23.2025.pdf",
  //   location: { state: "Texas", city: "Houston" },
  //   yearsPracticalPhysician: "10+ yrs ",
  //   yearsResearchClinicalTrail: "",
  //   numberOfClinicalTrail: "",
  // },
  // {
  //   image: MohamedShalaby,
  //   name: "Mohamed Shalaby, M.D., F.A.C.C",
  //   TheraupaticalArea: ["Cardiology"],
  //   specialization: ["Cardiology"],
  //   site: "KUR @ Axsendo Clinical Research – Houston, TX",
  //   link: "/network/cv/Dr. Mohamed Shalaby - ACR-KUR - Cardiology - TX - 09.25.2025.pdf",
  //   location: { state: "Texas", city: "Houston" },
  //   yearsPracticalPhysician: "20+ yrs ",
  //   yearsResearchClinicalTrail: "29+ yrs ",
  //   numberOfClinicalTrail: "6",
  // },
  // {
  //   image: AramisCosme,
  //   name: "Aramis Cosme, M.D.",
  //   TheraupaticalArea: ["Primary Care"],
  //   specialization: ["Internal Medicine"],
  //   site: "KUR @ Axsendo Clinical Research – Houston, TX",
  //   link: "/network/cv/Dr. Aramis Cosme - ACR - KUR - Internal Medicine TX - 9.24.2025.pdf",
  //   location: { state: "Texas", city: "Houston" },
  //   yearsPracticalPhysician: "8+ yrs ",
  //   yearsResearchClinicalTrail: "5+ yrs ",
  //   numberOfClinicalTrail: "7",
  // },
  // {
  //   image: UlomaOkundaye,
  //   name: "Uloma Okundaye, ARNP-BC",
  //   TheraupaticalArea: ["Psychiatry", "Primary Care"],
  //   specialization: ["Psychiatry & Family Medicine"],
  //   site: "KUR @ Axsendo Clinical Research – Houston, TX",
  //   link: "/network/cv/Dr. Uloma Okundaye  - ACR - KUR - Mental & Women's Health TX - 9.24.2025.pdf",
  //   location: { state: "Texas", city: "Houston" },
  //   yearsPracticalPhysician: "19+ yrs ",
  //   yearsResearchClinicalTrail: "9+ yrs ",
  //   numberOfClinicalTrail: "10",
  // },
  // {
  //   image: LanceLaFleur,
  //   name: "J. Lance LaFleur, M.D., MBA",
  //   TheraupaticalArea: ["Anesthesia", "Interventional Pain"],
  //   specialization: ["Anesthesia, Interventional Pain"],
  //   site: "KUR @ Axsendo Clinical Research – Houston, TX",
  //   link: "/network/cv/Dr. Lance LaFleur - ACR - KUR - Anesthesia Interventional Pain TX - 09.24.2025.pdf",
  //   location: { state: "Texas", city: "Houston" },
  //   yearsPracticalPhysician: "13+ yrs ",
  //   yearsResearchClinicalTrail: "9+ yrs ",
  //   numberOfClinicalTrail: "23",
  // },
  // {
  //   image: LisaKopas,
  //   name: "Lisa M. Kopas, M.D.",
  //   TheraupaticalArea: ["Pulmonology"],
  //   specialization: ["Pulmonary Medicine"],
  //   site: "KUR @ Axsendo Clinical Research at PCCS – Houston, TX",
  //   link: "/network/cv/Dr. Lisa Kopas - ACR - KUR - Pulmonary Medicine TX - 9.23.2025.pdf",
  //   location: { state: "Texas", city: "Houston" },
  //   yearsPracticalPhysician: "15+ yrs ",
  //   yearsResearchClinicalTrail: "12+ yrs ",
  //   numberOfClinicalTrail: "13",
  // },
  // {
  //   image: RandalLepow,
  //   name: "Randal M. Lepow, DPM",
  //   TheraupaticalArea: ["Podiatry"],
  //   specialization: ["Podiatry"],
  //   site: "KUR @ Axsendo Clinical Research – Houston, TX",
  //   link: "/network/cv/Dr. Randal M. Lepow - ACR - KUR - Podiatry - TX - 09.25.2025.pdf",
  //   location: { state: "Texas", city: "Houston" },
  //   yearsPracticalPhysician: "40+ yrs ",
  //   yearsResearchClinicalTrail: "2+ yrs ",
  //   numberOfClinicalTrail: "2",
  // },
  // {
  //   image: YazanAbdeen,
  //   name: "Yazan Abdeen, M.D., MHCA, FCCP, CHCQM",
  //   TheraupaticalArea: ["Pulmonology", "Emergency Medicine"],
  //   specialization: ["Pulmonary & Critical Care Medicine"],
  //   site: "KUR @ Axsendo Clinical Research – Houston, TX",
  //   link: "/network/cv/Dr. Yazan Abdeen - ACR - KUR - Pulmonary Critical Care TX - 9.24.2025.pdf",
  //   location: { state: "Texas", city: "Houston" },
  //   yearsPracticalPhysician: "10+ yrs ",
  //   yearsResearchClinicalTrail: "",
  //   numberOfClinicalTrail: "",
  // },
  // {
  //   image: MicaelaSimon,
  //   name: "Micaela Simon, FNP-C, AAHIVS",
  //   TheraupaticalArea: ["Primary Care"],
  //   specialization: ["Family Medicine"],
  //   site: "KUR @ Axsendo Clinical Research  – Phoenix, AZ",
  //   link: "/network/cv/Michaela Simon - ACR - KUR - Family Medicine AZ 09.24.2025.pdf",
  //   location: { state: "Arizona", city: "Phoenix" },
  //   yearsPracticalPhysician: "18+ yrs ",
  //   yearsResearchClinicalTrail: "3+ yrs ",
  //   numberOfClinicalTrail: "2",
  // },
  // {
  //   image: JuliaKieffer,
  //   name: "Julia Kieffer, FNP-C",
  //   TheraupaticalArea: ["Primary Care"],
  //   specialization: ["Family Medicine"],
  //   site: "KUR @ Axsendo Clinical Research  – Phoenix, AZ",
  //   link: "/network/cv/Dr. Julia Kieffer - ACR - KUR - Family Medicine AZ 9.22.2025.pdf",
  //   location: { state: "Arizona", city: "Phoenix" },
  //   yearsPracticalPhysician: "20+ yrs ",
  //   yearsResearchClinicalTrail: "",
  //   numberOfClinicalTrail: "",
  // },
  // {
  //   image: FrankLoVecchio,
  //   name: "Frank LoVecchio, D.O., MPH, FACEP",
  //   TheraupaticalArea: ["Emergency Medicine"],
  //   specialization: ["Emergency Medicine"],
  //   site: "KUR @ Axsendo Clinical Research  – Phoenix, AZ",
  //   link: "/network/cv/Dr. Frank LoVecchio - ACR - KUR - Emergency Medicine AZ - 9.23.2025.pdf",
  //   location: { state: "Arizona", city: "Phoenix" },
  //   yearsPracticalPhysician: "35+ yrs ",
  //   yearsResearchClinicalTrail: "20+ yrs ",
  //   numberOfClinicalTrail: "150",
  // },
  // {
  //   image: SamHaddad,
  //   name: "Sam Haddad, M.D.",
  //   TheraupaticalArea: ["Primary Care"],
  //   specialization: ["Internal Medicine"],
  //   site: "KUR @ Axsendo Clinical Research  – Phoenix, AZ",
  //   link: "/network/cv/Dr. Sam Haddad - ACR - KUR - Internal Medicine AZ - 09.23.2025.pdf",
  //   location: { state: "Arizona", city: "Phoenix" },
  //   yearsPracticalPhysician: "10+ yrs ",
  //   yearsResearchClinicalTrail: "8+ yrs ",
  //   numberOfClinicalTrail: "38",
  // },
  // {
  //   image: MadelineCordes,
  //   name: "Madeline Cordes, MD",
  //   TheraupaticalArea: ["Primary Care"],
  //   site: "KUR @ Axsendo Clinical Research  – Phoenix, AZ",
  //   link: "/network/cv/madeline-cordes-md",
  //   location: { state: "Arizona", city: "Phoenix" }
  // },
  // {
  //   image: NamrataChhabra,

  //   name: "Namrata Chhabra, MD",
  //   TheraupaticalArea: ["Primary Care"],
  //   site: "KUR @ Axsendo Clinical Research  – Phoenix, AZ",
  //   link: "/network/cv/namrata-chhabra-md",
  //   location: { state: "Arizona", city: "Phoenix" }
  // },
  // {
  //   image: MarcusBlake,
  //   name: "Marcus Blake, MD",
  //   TheraupaticalArea: ["Primary Care"],
  //   site: "KUR @ Axsendo Clinical Research  – Phoenix, AZ",
  //   link: "/network/cv/marcus-blake-md",
  //   location: { state: "Arizona", city: "Phoenix" }
  // },
  // {
  //   image: CarlosMarquez,
  //   name: "Carlos Marquez, MD",
  //   TheraupaticalArea: ["Primary Care"],
  //   site: "KUR @ Axsendo Clinical Research  – Phoenix, AZ",
  //   link: "/network/cv/carlos-marquez-md",
  //   location: { state: "Arizona", city: "Phoenix" }
  // },
  // {
  //   image: LilaGanji,
  //   name: "Lila Ganji, MD",
  //   TheraupaticalArea: ["Primary Care"],
  //   site: "KUR @ Axsendo Clinical Research  – Phoenix, AZ",
  //   link: "/network/cv/lila-ganji-md",
  //   location: { state: "Arizona", city: "Phoenix" }
  // },
  // {
];
export const investigatorsList = investigators.sort((a, b) =>
  a.name.localeCompare(b.name)
);
